import { X } from 'lucide-react';
import { orDash } from '../../../../utils/schema-parse';
import type { ResumoMapa } from './resumo-view.types';

interface MapasInfestacaoModalProps {
  titulo: string;
  mapas: ResumoMapa[];
  open: boolean;
  onClose: () => void;
}

const MapasInfestacaoModal = ({
  titulo,
  mapas,
  open,
  onClose,
}: MapasInfestacaoModalProps) => {
  if (!open) return null;

  return (
    <div
      role="presentation"
      className="rv-infest-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
        className="rv-infest-dialog"
      >
        <div className="rv-infest-header">
          <h2 className="rv-infest-title">Mapas de Infestação - {titulo}</h2>
          <button
            type="button"
            aria-label="Fechar"
            className="rv-infest-close"
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </div>

        <div className="rv-infest-body">
          <p className="rv-infest-subtitle">
            Visualização completa de todos os mapas de infestação registrados
            neste talhão.
          </p>

          <div className="rv-infest-grid">
            {mapas.map((mapa) => (
              <div key={mapa.mapaInfestacao} className="rv-infest-card">
                <div className="rv-infest-card-title">
                  {orDash(mapa.titulo)}
                </div>
                <img
                  alt={orDash(mapa.titulo)}
                  className="rv-infest-card-image"
                  src={mapa.mapaInfestacao ?? undefined}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapasInfestacaoModal;
